import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { User } from "../types";

// Propsの型定義
interface PrivateRouteProps {
  user: User | null; // ログイン前はnullの可能性があるため
}

const PrivateRoute = ({ user }: PrivateRouteProps) => {
  // userが存在すればそのまま子ルート(Outlet)を表示し、user情報を渡す
  // 存在しなければログイン画面へリダイレクト
  return user ? <Outlet context={user} /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
